import { IRootState } from "../../store";

export const selectWaitingList = (state: IRootState) =>
  state.waiting.waitingList;
